export default __webpack_public_path__ + "static/media/5Blog.44370cbb.png";